import {
  SET_DATA_FIELD,
  SET_HEADER_TITLE,
  SET_IMAGE_GROUP,
  SET_IMAGE_HEADER,
  SET_MODE_HISTORY,
  SET_OPEN_MENU,
} from "./constants";

export type STATE = {
  isOpenMenu: boolean;
  imageGroup: string;
  imageHeader: number;
  textWhatIs: string[];
  dataByMode: string[];
  headerTitle: string;
  modeHistory: 1 | 2 | 3;
};

const initState: STATE = {
  isOpenMenu: false,
  imageGroup: "",
  imageHeader: 0,
  textWhatIs: [],
  dataByMode: [],
  headerTitle: "",
  modeHistory: 2,
};

function reducer(state: any, action: any) {
  switch (action.type) {
    case SET_OPEN_MENU:
      return {
        ...state,
        isOpenMenu: action.payload,
      };
    case SET_IMAGE_GROUP:
      return {
        ...state,
        imageGroup: action.payload,
      };
    case SET_IMAGE_HEADER:
      return {
        ...state,
        imageHeader: state.imageHeader + 1,
      };
    case SET_DATA_FIELD:
      return {
        ...state,
        dataByMode: action.payload,
      };
    case SET_HEADER_TITLE:
      return {
        ...state,
        headerTitle: action.payload,
      };
    case SET_MODE_HISTORY:
      return {
        ...state,
        modeHistory: action.payload,
      };
  }
}

export { initState };
export default reducer;
